import React from 'react';

type SortOpt = { id: number, num: number, lbl: string, reverse: boolean };

export class SortSelection extends React.Component<{
  options: string[],
  onChange: (selection : number, reverse : boolean) => void
}> {
  state = {
    selectedOption: 0,
    options: [] as SortOpt[]
  };

  componentDidMount() {
    const opts = [] as SortOpt[];
    this.props.options.forEach((opt, indx) => {
      opts.push({id: indx*2,   num: indx, lbl: opt, reverse: false});
      opts.push({id: indx*2+1, num: indx, lbl: opt, reverse: true});
    });
    this.setState({options: opts});
  }

  private onSelectChanged(e : React.ChangeEvent<HTMLSelectElement>) {
    const opt_id : number = parseInt(e.target.value);
    const opt = this.state.options.filter(o => o.id === opt_id)[0]

    this.props.onChange(opt.num, opt.reverse);
    this.setState({ selectedOption: opt.num });
  }

  render() {
    return <select className="td-sort-selection" onChange={this.onSelectChanged.bind(this)}>
      { this.state.options.filter(o => !o.reverse || o.num === this.state.selectedOption).map(o => <option key={o.id} value={o.id}>
        { o.lbl }
        { this.state.selectedOption === o.num && !o.reverse && ' \u2191'}
        { this.state.selectedOption === o.num && o.reverse && ' \u2193' }
      </option>)}
    </select>;
  }
}

export type compFn<T> = (t1 : T, t2 : T, reverse? : boolean) => number;
export function mkCompFn<T,V>(valGetter : ((itm : T) => V|undefined), compFn : ((v1 : V, v2 : V) => number)) : compFn<T> {
  return (i1, i2, reverse) => {
    const v1 = valGetter(i1);
    const v2 = valGetter(i2);
    let res = 0;

    if (typeof v1 !== 'undefined' && typeof v2 !== 'undefined') {
      res = compFn(v1, v2);
    } else if (typeof v1 !== 'undefined') {
      res = -1;
    } else if (typeof v2 !== 'undefined') {
      res = 1;
    }

    return res * (reverse ? -1 : 1);
  };
};